import { Vue, Prop, Component } from 'vue-property-decorator'

import { VSkeletonLoader } from 'vuetify/lib'
import './Obfuscate.scss'
@Component({})
export class ObfuscateField extends Vue {
	isObfuscate: boolean = true
	@Prop({ type: String, required: false, default: 'd-flex justify-end' }) alignObfuscate!: string
	@Prop({ type: String, required: false, default: '120' }) width!: string

	render() {
		return (
			<VSkeletonLoader
				boilerplate
				tile
				type="heading"
				class={this.alignObfuscate}
				width={this.width}
				height="20"
				loading={this.isObfuscate}
			>
				{this.$scopedSlots.default}
			</VSkeletonLoader>
		)
	}
	mounted() {
		this.$root.$on('emmit-obfuscate', () => (this.isObfuscate = !this.isObfuscate))
	}
}

export default ObfuscateField
